import React from "react";
import { PageSeoProvider } from "./context/PageSeoContext";

// Shared by gatsby-ssr.js and gatsby-browser.js. Both must use the identical
// implementation — if only SSR wrapped the tree, client-side navigation would
// silently drop per-page SEO.
export const wrapPageElement = ({ element, props }) => (
  <PageSeoProvider value={props.pageContext && props.pageContext.pageSeo}>{element}</PageSeoProvider>
);
